import produce from 'immer';
import margeById from '../../../helpers/margeById';

export const actions = {
  GET_PENDING_ARTISANS_PRIVATE_INQUIRIES:
    'GET_PENDING_ARTISANS_PRIVATE_INQUIRIES',

  GET_PENDING_ARTISANS_PRIVATE_INQUIRIES_SUCCESS:
    'GET_PENDING_ARTISANS_PRIVATE_INQUIRIES_SUCCESS',

  GET_SINGLE_ARTISAN_PRIVATE_INQUIRY: 'GET_SINGLE_ARTISAN_PRIVATE_INQUIRY',
  GET_SINGLE_ARTISAN_PRIVATE_INQUIRY_SUCCESS:
    'GET_SINGLE_ARTISAN_PRIVATE_INQUIRY_SUCCESS',

  DELETE_SINGLE_ARTISAN_PRIVATE_INQUIRY:
    'DELETE_SINGLE_ARTISAN_PRIVATE_INQUIRY',
  DELETE_SINGLE_ARTISAN_PRIVATE_INQUIRY_SUCCESS:
    'DELETE_SINGLE_ARTISAN_PRIVATE_INQUIRY_SUCCESS',

  MODERATE_CREATE_ARTISAN_PRIVATE_INQUIRY:
    'MODERATE_CREATE_ARTISAN_PRIVATE_INQUIRY',
  MODERATE_CREATE_ARTISAN_PRIVATE_INQUIRY_SUCCESS:
    'MODERATE_CREATE_ARTISAN_PRIVATE_INQUIRY_SUCCESS',

  UPDATE_PENDING_ARTISAN_PRIVATE_INQUIREY:
    'UPDATE_PENDING_ARTISAN_PRIVATE_INQUIREY',
  UPDATE_PENDING_ARTISAN_PRIVATE_INQUIREY_SUCCESS:
    'UPDATE_PENDING_ARTISAN_PRIVATE_INQUIREY_SUCCESS',

  SET_PENDING_ARTISANS_PRIVATE_INQUIRY_IS_LOADING:
    'SET_PENDING_ARTISANS_PRIVATE_INQUIRY_IS_LOADING',

  SET_PENDING_ARTISANS_PRIVATE_INQUIRY_COUNT:
    'SET_PENDING_ARTISANS_PRIVATE_INQUIRY_COUNT',
};

const initalState = {
  items: [],
  isLoading: false,
  count: 0,
};

export default produce((draft, action) => {
  const { type, payload } = action;

  if (!draft) return initalState;

  switch (type) {
    case actions.GET_PENDING_ARTISANS_PRIVATE_INQUIRIES_SUCCESS: {
      const currentPrivateInquiry = draft.items;
      const privateInquiry = payload;
      draft.items = margeById(currentPrivateInquiry, privateInquiry);
      break;
    }

    case actions.UPDATE_PENDING_ARTISAN_PRIVATE_INQUIREY_SUCCESS: {
      const currentItems = draft.items;
      const updatedItems = currentItems.filter((item) => payload !== item._id);
      draft.items = updatedItems;
      break;
    }

    case actions.SET_PENDING_ARTISANS_PRIVATE_INQUIRY_COUNT: {
      draft.count = payload;
      break;
    }

    case actions.GET_SINGLE_ARTISAN_PRIVATE_INQUIRY_SUCCESS: {
      const currentArtisans = draft.items;
      draft.items = margeById(currentArtisans, [payload]);
      break;
    }
    case actions.SET_PENDING_ARTISANS_PRIVATE_INQUIRY_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }
    case actions.DELETE_SINGLE_ARTISAN_PRIVATE_INQUIRY_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload);
      break;
    }
    case actions.MODERATE_CREATE_ARTISAN_PRIVATE_INQUIRY_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload.id)
      break;
    }
  }
});
